import React, { useEffect, useState } from "react";
import {
  Box,
  CssBaseline,
  Paper,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
import api from "../../api/axiosInstance"
import AppBarComponent from "../../components/layout/AppbarComponent";
import { useConfirm } from "../../utils/useConfirm";
import { toast, ToastContainer } from "react-toastify";
import "../../utils/THSarabunNew-normal";


export default function ApproveEstimate() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { confirm } = useConfirm();

  const [software, setSoftware] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSoftware = async () => {
      try {
        const res = await api.get(`api/software/getsoftware/${id}`);
        setSoftware(res.data);
      } catch (err) {
        console.error("Error fetching software", err);
      } finally {
        setLoading(false);
      }
    };

    loadSoftware();
  }, [id]);


  if (loading) return <Typography>กำลังโหลดข้อมูล...</Typography>;

  const baseLineMH =
    software.dev_ratio
      ? (software.dev_manhours * 100) / software.dev_ratio
      : 0;

  const sdlcRatio = {
    การวางแผน: software.plan_ratio || 0,
    การวิเคราะห์ความต้องการ: software.req_ratio || 0,
    การออกแบบซอฟต์แวร์: software.design_ratio || 0,
    การพัฒนาซอฟต์แวร์: software.dev_ratio || 0,
    การทดสอบซอฟต์แวร์: software.test_ratio || 0,
    การส่งมอบ: software.deliver_ratio || 0,
  };

  const supportRatio = {
    ความเสี่ยง: software.risk_ratio || 0,
    เทคโนโลยีที่คิดค้นขึ้นใหม่: software.tech_ratio || 0,
    ปัจจัยอื่นๆ: software.other_ratio || 0,
  };

  const manmonth = (mh) => mh / 152;

  // Calculated rows
  const sdlcRows = Object.keys(sdlcRatio).map((process) => {
    const percent = sdlcRatio[process];
    const mh = (baseLineMH * percent) / 100;
    const mm = manmonth(mh);

    return {
      process,
      percent,
      mh,
      mm,
    };
  });

  const supportRows = Object.keys(supportRatio).map((process) => {
    const percent = supportRatio[process];
    const mh = (baseLineMH * percent) / 100;
    const mm = manmonth(mh);

    return {
      process,
      percent,
      mh,
      mm,
    };
  });

  const totalPercent =
    sdlcRows.reduce((sum, r) => sum + Number(r.percent || 0), 0) +
    supportRows.reduce((sum, r) => sum + Number(r.percent || 0), 0);

  const totalMH =
    sdlcRows.reduce((sum, r) => sum + Number(r.mh || 0), 0) +
    supportRows.reduce((sum, r) => sum + Number(r.mh || 0), 0);

  const handleApprove = async () => {
  const ok = await confirm("คุณแน่ใจหรือไม่ที่จะอนุมัติ?");
  if (!ok) return;

  try {
    await api.put("api/software/editsoftwarestatus", {
      software_id: id,
      status: "finished",
    });

    toast.success("อนุมัติสำเร็จ!", {
      onClose: () => navigate("/home"),
      autoClose: 1500,
    });

  } catch (err) {
    toast.error("อนุมัติไม่สำเร็จ");
  }
};

  // Go back to edit pages
  const handleReject = async () => {
    const ok = await confirm("คุณต้องการกลับไปแก้ไขใช่หรือไม่");
    if (!ok) return;

    try {
      if (software.status === "finished") {
        await api.put(`api/software/editsoftwarestatus`, {
          software_id: id,
          status: "onProgress",
        });
      }
    } catch (err) {
      console.error(err);
    }
    navigate(`/software/edit/${id}`);
  };

  const handleExportPDF = async () => {
    try {
      const res = await api.get(
        `/api/export/estimate/${id}/pdf`,
        { responseType: "blob" }
      );

      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );

      window.open(url);
    } catch (err) {
      console.error("EXPORT PDF ERROR:", err);
    }
  };

  return (
    <>
      <CssBaseline />
      <AppBarComponent />
      <ToastContainer position="top-center" autoClose={2000} />

      <Box sx={{ p: 2, backgroundColor: "#DFF6F0", minHeight: "100vh" }}>
        <Paper sx={{ width: "95%", m: "0 auto", p: 3, borderRadius: 2 }}>
          <Typography variant="h6" fontWeight="bold" mb={2}>
            ตรวจสอบและอนุมัติข้อมูลโครงการ
          </Typography>

          <Typography variant="h6" mb={2} sx={{ fontWeight: "bold" }}>
            {id}
            {"_"}
            {software.software_name ? software.software_name : ""}
          </Typography>

          <TableContainer sx={{ mt: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>กระบวนการ</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    อัตราส่วน (%)
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    ค่าความพยายาม (Man-Hours)
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    ค่าความพยายาม (Man-Month)
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sdlcRows.map((r, index) => (
                  <TableRow key={index}>
                    <TableCell>{r.process}</TableCell>
                    <TableCell>{r.percent}%</TableCell>
                    <TableCell>{r.mh.toFixed(2)}</TableCell>
                    <TableCell>{r.mm.toFixed(2)}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>รวม</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    {sdlcRows
                      .reduce((sum, r) => sum + Number(r.percent || 0), 0)
                      .toFixed(2)}
                    %
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    {sdlcRows
                      .reduce((sum, r) => sum + Number(r.mh || 0), 0)
                      .toFixed(2)}
                  </TableCell>
                </TableRow>

                {supportRows.map((r, index) => (
                  <TableRow key={index}>
                    <TableCell>{r.process}</TableCell>
                    <TableCell>{r.percent}%</TableCell>
                    <TableCell>{r.mh.toFixed(2)}</TableCell>
                    <TableCell>{r.mm.toFixed(2)}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>รวม</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    {totalPercent.toFixed(2)} %
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    {totalMH.toFixed(2)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Box mt={2}>
            <Typography>
              <b>ค่าจ้างในการพัฒนาซอฟต์แวร์ :</b>{" "}
              {software.cost?.toLocaleString()} บาท
            </Typography>
            <Typography>
              <b>ระยะเวลาในการพัฒนาซอฟต์แวร์ :</b> {software.duration} เดือน
            </Typography>
            <Typography>
              <b>ผู้ประเมิน :</b> {software.estimator}
            </Typography>
          </Box>

          <Typography variant="h6" mt={3} fontWeight="bold">
            คุณต้องการอนุมัติข้อมูลโครงการนี้หรือไม่?
          </Typography>

          <Box display="flex" justifyContent="space-between" mt={3}>
            <Button variant="contained" color="error" onClick={handleReject}>
              ไม่อนุมัติ (กลับไปแก้ไข)
            </Button>



            <Box display="flex" gap={2} mt={3}>
              {software.dev_ratio && software.cost && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleExportPDF}
                >
                  Export PDF
                </Button>
              )}
              <Button
                variant="contained"
                color="success"
                onClick={handleApprove}
              >
                อนุมัติและปิดโครงการ
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  );
}
